<template lang="html">
    <div class="d-flex flex-column h-100 position-relative">
        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Promocodes</h2>
        </div>

        <div class="d-flex flex-column overflow-auto">
            <div class="d-flex justify-content-end pt-4 pr-3">
                <button class="btn blue wide mr-3" @click="cancelBtn">Cancel</button>
                <button class="btn wide mr-3" @click="saveBtn" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}">Save</button>
                <button class="btn wide mr-3" @click="publishBtn" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}">Publish</button>
                <button class="btn wide blue" @click="pressSeeAffectedEvents" :class="{'disabled': isPromocodeInvalid || !isValidWeekDays}" >Preview list of events</button>
            </div>

            <div class="px-3 py-4 d-flex flexGrow1">
                <div class="col-sm-12">
                    <promocode-form :promocode="promocode" @change="promocodeChanged" @hasWeekDays="weekDaysValidation($event)"></promocode-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import PromocodeForm from './components/promocodeForm'

    export default {
        data() {
            return {
                isPromocodeInvalid: true,
                promocode: null,
                promocodeValidation: null,
                isValidWeekDays: false
            }
        },
        created() {
            this.promocode = JSON.parse(JSON.stringify(this.getVirginPromocode));
        },
        computed: {
            ...mapGetters([
                'getVirginPromocode',
            ]),
        },
        methods: {
            ...mapActions([
                'createPromocodeDraft',
                'createPromocodeActive',
                'setSelectedPromocode',
                'openModal',
            ]),
            weekDaysValidation(isValid) {
                this.isValidWeekDays = isValid;
            },
            cancelBtn() {
                this.$router.push({name:'promocodes'})
            },
            saveBtn() {
                if (!this.isPromocodeInvalid && this.isValidWeekDays) {
                    this.createPromocodeDraft(this.promocode).then(response => {
                        this.$router.push({name:'promocodes'});
                    });
                } else {
                    this.promocodeValidation.promocode.$touch();
                }
            },
            publishBtn() {
                if (!this.isPromocodeInvalid && this.isValidWeekDays) {
                    this.createPromocodeActive(this.promocode).then(response => {
                        if(response.status == 200){
                            this.$router.push({name:'promocodes'});
                        }
                    });
                } else {
                    this.promocodeValidation.promocode.$touch();
                }
            },
            promocodeChanged(e) {
                this.isPromocodeInvalid = e.v.promocode.$invalid
                this.promocodeValidation = e.v
            },
            pressSeeAffectedEvents() {
                if (this.isPromocodeInvalid || !this.isValidWeekDays) {
                    this.promocodeValidation.promocode.$touch();
                    
                    return false;
                }

                this.setSelectedPromocode(this.promocode);
                this.openModal('PromocodeAffectedEvents');
            }
        },
        components: {
            PromocodeForm
        },
    }
</script>



// WEBPACK FOOTER //
// promocodeCreate.vue?2e886fa8